import { createOnErrorGraphql } from "@neonumy/neonumy-ui";
import i18n from "config/i18n/i18n";

// Import this function directly from the package will result in undefined translations
export const onErrorGraphql = createOnErrorGraphql(i18n);
